import * as React from "react";
import {Popup} from "../../../common/components/shared/popup/popup";
import {ValidatedValue} from "../../../helpers/validatedValue";
import SelectOwnedVehicleForm from "../../../common/components/shared/selectOwnedVehicleForm/selectOwnedVehicleForm";
import Button from "../../../common/components/shared/button/button";
import i18n from "../../../i18n/i18n";
import "./ownedVehiclePopup.scss";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../common/models/httpError";
import {Api} from "../../../helpers/api";
import {HttpError} from "../../../common/components/shared/httpError/httpError";
import {VehicleAssigmentService} from "../../services/vehicleAssigmentService";
import {OwnVehicleAssignmentModel} from "../../models/vehicleAssigment";
import Loader from "../../../common/components/shared/loader/loader";
import {setCookie} from "../../../helpers/cookiesUtils";
import Validator from "../../../helpers/validator";

interface OwnedVehiclePopupProps {
    displayPopup: boolean;
    closePopup: () => void;
    disabledButtonOnLoadData: boolean; // This props is needed for the tests to run properly
}

interface OwnedVehiclePopupState {
    ownedVehicles: OwnVehicleAssignmentModel | null;
    ownedVehiclesResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    selectedOwnVehicle: ValidatedValue<string | null>;
    isPopupActionWaiting: boolean;
    isSelectWithoutVehicleWaiting: boolean;
    vehicleActionsResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    action: "withVehicle" | "withoutVehicle" | null;
}

export default class OwnedVehiclePopup extends React.Component <OwnedVehiclePopupProps, OwnedVehiclePopupState> {
    constructor(props: any) {
        super(props);

        this.state = {
            selectedOwnVehicle: new ValidatedValue(""),
            ownedVehiclesResponse: undefined,
            ownedVehicles: null,
            isPopupActionWaiting: false,
            isSelectWithoutVehicleWaiting: false,
            vehicleActionsResponse: undefined,
            action: null
        };
    }

    public async componentDidMount() {
        const respons = await VehicleAssigmentService.getOwnVehicleAssignment();

        this.setState({
            ownedVehicles: respons?.data || [],
            ownedVehiclesResponse: respons
        });

        this.state.selectedOwnVehicle.setValue(this.state.ownedVehicles && this.state.ownedVehicles.assignedVehicleId ? this.state.ownedVehicles.assignedVehicleId : "");
    }

    public render(): React.ReactNode {
        return (
            <Popup
                open={this.props.displayPopup}
                className="owned-vehicle-popup"
                header={i18n.t("ownedVehiclePopup.header")}
                content={
                    <>
                        {this.renderContent()}
                        {this.renderVehicleActionsResponse()}
                    </>
                }
                actionText={i18n.t("ownedVehiclePopup.actionText")}
                hideCancelButton
                otherBtn={this.renderOtherBtn()}
                action={Api.isSuccess(this.state.ownedVehiclesResponse) ? this.selectWithOwnVehicle.bind(this) : undefined}
                testId="owned-vehicle-popup"
                disabledButton={this.disabledButtonOnLoadData()}
                isWaiting={this.state.isPopupActionWaiting}
            />
        );
    }

    private renderOtherBtn(): JSX.Element {
        return (
            <Button
                type="secondary"
                onClick={this.selectWithoutOwnVehicle.bind(this)}
                testId="owned-vehicle-popup-skip-btn"
                text={i18n.t("ownedVehiclePopup.otherBtn")}
                disabled={this.disabledButtonOnLoadData()}
                isWaiting={this.state.isSelectWithoutVehicleWaiting}
            />
        );
    }

    private renderContent(): JSX.Element {
        if (!Api.isSuccess(this.state.ownedVehiclesResponse)) {
            return (
                <HttpError
                    response={this.state.ownedVehiclesResponse}
                    cause={i18n.t("ownedVehiclePopup.dataLoadingError")}
                />
            );
        } else {

            if (this.state.ownedVehicles === null) {
                return <Loader/>;
            } else {
                if (this.state.ownedVehicles.ownVehicles && this.state.ownedVehicles.ownVehicles.length > 0) {
                    return (
                        <SelectOwnedVehicleForm
                            selectedOwnVehicle={this.state.selectedOwnVehicle}
                            ownedVehicles={this.state.ownedVehicles.ownVehicles}
                        />
                    );
                } else if (this.state.ownedVehicles.ownVehicles && this.state.ownedVehicles.ownVehicles.length === 0) {
                    return <span className="empty-message">{i18n.t("ownedVehiclePopup.emptyMessage")}</span>;
                } else return <></>;
            }
        }
    }

    private renderVehicleActionsResponse() {
        if (!Api.isSuccess(this.state.vehicleActionsResponse)) {
            const causeWithoutVehicle = i18n.t("ownedVehiclePopup.withoutVehicle");
            const causeWithVehicle = i18n.t("ownedVehiclePopup.withVehicle");
            const cause = `${i18n.t("ownedVehiclePopup.vehicleActions")} ${
                this.state.action === "withVehicle" ?
                    causeWithVehicle : causeWithoutVehicle}`;

            return (
                <HttpError
                    response={this.state.vehicleActionsResponse}
                    cause={cause}
                />
            );
        }
    }

    private async selectWithOwnVehicle() {
        this.setState({isPopupActionWaiting: true, vehicleActionsResponse: undefined});
        const notEmptyValidator = {
            name: "valueIsNotEmpty",
            fn: Validator.isNotEmpty,
            errorMessage: () => i18n.t("ownedVehiclePopup.noSelectErrorMessage")
        };
        this.state.selectedOwnVehicle.addValidators(notEmptyValidator);

        if (this.state.selectedOwnVehicle && this.state.selectedOwnVehicle.value && this.state.selectedOwnVehicle.isValid) {
            const response = await VehicleAssigmentService.assignOwnVehicle({vehicleId: this.state.selectedOwnVehicle.value});
            this.setState({vehicleActionsResponse: response, action: "withVehicle"});

            if (Api.isSuccess(response)) {
                setCookie("ownVehicleActionWasPerformed", "true", 1);

                this.props.closePopup();
            }
        } else {
            this.state.selectedOwnVehicle.validate();
        }

        this.setState({isPopupActionWaiting: false});
    }

    private async selectWithoutOwnVehicle() {
        this.setState({isSelectWithoutVehicleWaiting: true, vehicleActionsResponse: undefined});

        let response;
        if(this.state.selectedOwnVehicle && this.state.selectedOwnVehicle.value) {
            response = await VehicleAssigmentService.unassignOwnVehicle();
        } else {
            response = undefined;

            setCookie("ownVehicleActionWasPerformed", "true", 1);
            this.props.closePopup();
        }
        this.setState({vehicleActionsResponse: response, action: "withoutVehicle"});

        if (Api.isSuccess(response)) {
            setCookie("ownVehicleActionWasPerformed", "true", 1);

            this.setState({isSelectWithoutVehicleWaiting: false});
            this.props.closePopup();
        } else this.setState({isSelectWithoutVehicleWaiting: false});
    }

    private disabledButtonOnLoadData() :boolean {
        return this.props.disabledButtonOnLoadData && !Api.isSuccess(this.state.ownedVehiclesResponse);
    }
}